import React, { useEffect, useState } from "react";
import { useClasses } from "../../..";
import classNames from "classnames";
import ReactDOM from "react-dom";
const menuStyles = (theme) => {
    return {
        menu: {
            position: "absolute",
            backgroundColor: "#fff",
            boxSizing: "border-box",
            boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)",
            borderRadius: "2px",
            padding: "16px",
            margin: "0px",
            height: "250px",
            overflowY: "scroll",
        },
        curtain: {
            position: "fixed",
            top: "0px",
            left: "0px",
            height: "100%",
            width: "100%",
            zIndex: "99",
        },
    };
};
const setId = (node, id) => {
    node.setAttribute("id", id);
    return node;
};
const Menu = (props) => {
    var _a;
    const classes = useClasses(menuStyles, props);
    const { anchor } = props;
    const [position, setPosition] = useState(anchor && anchor.current ? anchor.current.getBoundingClientRect() : null);
    const { top = 0, left = 0, width = 0, height = 0 } = position || {};
    const windowBottom = window.innerHeight ||
        document.documentElement.clientHeight ||
        document.getElementsByTagName("body")[0].clientHeight;
    const menuEnd = top + height + 258;
    const toAlignAt = menuEnd > windowBottom ? window.innerHeight - 258 : top + height;
    useEffect(() => {
        function handleResize() {
            if (anchor && anchor.current)
                setPosition(anchor.current.getBoundingClientRect());
        }
        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleResize);
        if (props.onFocus)
            props.onFocus();
        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleResize);
            if (props.onBlur)
                props.onBlur();
        };
    });
    return ReactDOM.createPortal(React.createElement("div", { className: classNames(classes.curtain, (_a = props.override) === null || _a === void 0 ? void 0 : _a.curtain), onClick: props.onClose },
        React.createElement("div", { className: classes.menu, style: { top: toAlignAt, left, width } }, props.children)), document.getElementById("theme-presenter") ||
        document.body.appendChild(setId(document.createElement("div"), "theme-presenter")));
};
export default Menu;
